import { getConfig } from "@bc/react-config";


export const getUrlPro = () => {
  return getConfig("REACT_APP_SAGA_PRO_URL");
};

export const getUrlPart = () => {
  return getConfig("REACT_APP_SAGA_PART_URL");
};
